<template>
  <div
    class="latest-updates"
    data-test-id="latest-updates"
  >
    <div class="community-hub__section-header">
      <img
        src="/common/nexus/latest-updates.png"
        alt=""
        class="community-hub__section-header-image"
      >
      <h2
        class="community-hub__section-heading"
        data-test-id="latest-updates-heading"
      >Latest Updates</h2>
    </div>
    <loading-spinner v-if="!activityStream.activities && loading !== 0" />
    <div v-else class="latest-updates__container">
      <activity-stream
        v-if="activitiesAvailable"
        :activity-stream="activityStream"
        show-user-avatar
        show-username
        show-activity-type
        :has-scroll-pagination="false"
      >
        <div v-if="siteHasFeature('status_updates')" class="single-activity single-activity--flex single-activity--status">
          <user-status :user="currentUser" class="user-status--full-width">
            How are you feeling?
          </user-status>
        </div>
      </activity-stream>
    </div>
    <loading-spinner
      v-if="activityStream.activities && loading !== 0"
      class="loading-spinner--less-padding"
    />
    <button
      v-else-if="activityStream.pageInfo && activityStream.pageInfo.hasNextPage"
      type="button"
      class="latest-updates__more-link text-button text-button--center"
      data-test-id="latest-updates-more-link"
      @click="loadMore"
    >View more updates</button>
  </div>
</template>

<script>
import UserStatus from '@/components/User/Statuses/UserStatus.vue';
import ActivityStream from '@/components/User/Activity/ActivityStream.vue';
import { ACTIVITY_STREAM_QUERY } from '@/graphql/queries/activity-stream-queries';
import { mapGetters } from 'vuex';

export default {
  name: 'LatestUpdates',
  components: {
    UserStatus,
    ActivityStream,
  },
  data() {
    return {
      activityStream: {},
      first: 6,
      loading: 0,
    };
  },
  computed: {
    ...mapGetters(['currentUser', 'loggedIn', 'siteHasFeature']),
    activitiesAvailable() {
      return Object.keys(this.activityStream).includes('activities');
    },
  },
  methods: {
    loadMore() {
      const scrollPos = window.scrollY;

      this.$apollo.queries.activityStream.fetchMore({
        variables: {
          first: this.first,
          after: this.activityStream.pageInfo.endId,
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          const newActivities = fetchMoreResult.activityStream.activities
            .filter((newActivity) => !previousResult.activityStream.activities
              .some((oldActivity) => oldActivity.id === newActivity.id));
          return {
            activityStream: {
              // eslint-disable-next-line no-underscore-dangle
              __typename: fetchMoreResult.activityStream.__typename,
              activities: [
                ...previousResult.activityStream.activities,
                ...newActivities,
              ],
              pageInfo: fetchMoreResult.activityStream.pageInfo,
            },
          };
        },
      }).then(() => {
        // Force the scroll position to remain the same, this prevents weirdness
        // on mobile when results would be injected above current scroll position
        window.scrollTo(0, scrollPos);
      });
    },
  },
  apollo: {
    activityStream: {
      query: ACTIVITY_STREAM_QUERY,
      variables() {
        return {
          first: this.first,
        };
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_latest-updates';
  @import '@/stylesheets/components/_single-activity';
</style>

<docs>
A component that renders activity for all users on the site.
The component also includes a UserStatus input that allows the current user to
post a status, if the user is not logged in they will be prompted to login if they
try to interact with the UserStatus component.
</docs>
